/**
 * Home Instagram Feed - Editorial Zen
 * 
 * Fetches and renders the latest Instagram posts using the Basic Display API.
 * Maintains UI consistency with the static version.
 */
class HomeInstagram {
    constructor(container) {
        this.container = container;
        // Trim token to prevent issues with accidental whitespace
        this.token = (container.dataset.accessToken || '').trim();
        this.limit = parseInt(container.dataset.count) || 6;
        this.grid = container.querySelector('.insta-grid');
        
        if (this.token && this.token.length > 10) {
            this.init();
        } else {
            console.warn('Home Instagram: No valid access token provided. Showing static blocks or placeholders.');
        }
    }

    async init() {
        this.container.classList.add('is-loading');

        try {
            const endpoint = `https://graph.instagram.com/me/media?fields=id,media_type,media_url&access_token=${encodeURIComponent(this.token)}&limit=${this.limit}`;
            const response = await fetch(endpoint);
            const data = await response.json();

            if (!response.ok) {
                // This is the CRITICAL part: log the actual error from Instagram
                console.error('Home Instagram: API Error Response', data);
                return;
            }

            if (data && data.data && Array.isArray(data.data)) {
                this.render(data.data);
            } else {
                console.warn('Home Instagram: API returned successful response but no media found.', data);
            }
        } catch (error) {
            console.error('Home Instagram: Network or Fetch Error', error);
        } finally {
            this.container.classList.remove('is-loading');
        }
    }

    render(media) {
        if (!media || !media.length) return;
        if (!this.grid) return;

        // Clear existing static blocks/placeholders ONLY if we have API data to replace them
        this.grid.innerHTML = '';

        media.forEach(item => {
            // Instagram Basic Display API media types: IMAGE, VIDEO, CAROUSEL_ALBUM
            const isVideo = item.media_type === 'VIDEO';
            const imageUrl = isVideo ? item.thumbnail_url : item.media_url;
            
            if (!imageUrl) return;

            const itemHtml = `
                <div class="insta-item">
                    <a href="${item.permalink}" target="_blank" rel="noopener noreferrer" aria-label="View on Instagram">
                        <img src="${imageUrl}" alt="${item.caption ? item.caption.substring(0, 100).replace(/"/g, '&quot;') : 'Instagram Post'}" loading="lazy" width="600" height="600">
                    </a>
                </div>
            `;
            this.grid.insertAdjacentHTML('beforeend', itemHtml);
        });
    }
}

// Initial session load
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-section-type="instagram-feed"]').forEach(container => {
        new HomeInstagram(container);
    });
});

// Theme Editor events (Shopify 2.0)
document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('[data-section-type="instagram-feed"]');
    if (container) {
        new HomeInstagram(container);
    }
});
